import AllSeasons from "../schemas/AllSeasons";
import { nanoid } from "nanoid";

export const allSeasons: AllSeasons[] = [
    {
        id: nanoid(),
        title: "2009/10",
        subTitle: "עונת הג'נסיס: שישה שחקני פרנצ'ייז לקבוצה",
        podiumWinners: "1. Pheonix Bastards\n2. Dom's Hawks\n3. B-Movie Blazers"
    },
    {
        id: nanoid(),
        title: "2010/11",
        subTitle: "ארבעה שחקני פרנצ'ייז, קיפר חופשי וסליפר לקבוצה",
        podiumWinners: "1. The Crashalot Bobcat\n2. Pheonix Bastards\n3. B-Movie Blazers"
    },
    {
        id: nanoid(),
        title: "2011/12",
        subTitle: "שחקן פרנצ'ייז יחיד, שני קיפרים חופשיים ושלושה סליפרים לקבוצה",
        podiumWinners: "1. Brooklyn Nets\n2. The Crashalot Bobcat\n3. Pheonix Bastards"
    },
    {
        id: nanoid(),
        title: "2012/13",
        podiumWinners: "1. San Francisco\n2. Pheonix Bastards\n3. philoozers"
    },
    {
        id: nanoid(),
        title: "2013/14",
        subTitle: "הוספת דראפט וטרנים, הגבלת מהלכים למכסה של 380 בעונה",
        podiumWinners: "1. Pheonix Bastards\n2. San Francisco\n3. B-Movie Blazers"
    },
    {
        id: nanoid(),
        title: "2014/15",
        subTitle: "מכסה קבועה של 200 מהלכים",
        podiumWinners: "1. San Francisco\n2. Dom's Hawks\n3. The Crashalot Bobcat"
    },
    {
        id: nanoid(),
        title: "2015/16",
        podiumWinners: "1. San Francisco + The Crashalot Bobcat\n3. Dom's Hawks\n"
    },
    {
        id: nanoid(),
        title: "2016/17",
        podiumWinners: "1. All That Jazz\n2. Brook-Lin Durniets\n3. Chicago Gangstas"
    },
    {
        id: nanoid(),
        title: "2017/18",
        subTitle: "הוספת משבצת לקיפרים פצועים",
        podiumWinners: "1. All That Jazz + Orlando DunkN GoNutz\n3. B-Movie Blazers + Detroit Jews 33 + Pheonix Bastards"
    },
    {
        id: nanoid(),
        title: "2018/19",
        podiumWinners: "1. All That Jazz\n2. Orlando DunkN GoNutz\n 3. Chicago Fire"
    },
    {
        id: nanoid(),
        title: "2019/20",
        subTitle: "שינוי סדר בחירות בדראפט וטרנים ממקום 9 ומעלה למקום 5 ומטה",
        podiumWinners: "1. B-Movie Blazers\n2. Chicago's on Fire\n3. Pheonix Bastards"
    },
    {
        id: nanoid(),
        title: "2020/21",
        podiumWinners: "1. All That Jazz\n2. Pheonix Bastards\n3. Dom's Hawks"
    },
    {
        id: nanoid(),
        title: "2021/22",
        podiumWinners: "1. B-Movie Blazers\n2. Chicago's on Fire\n3. The Crashalot Bobcat"
    },
    {
        id: nanoid(),
        title: "2022/23",
        podiumWinners: "1. B-Movie Blazers\n2. Indy Halicopters + Pheonix Bastards"
    },
    {
        id: nanoid(),
        title: "2023/24",
        podiumWinners: "1. Chicago's on Fire\n 2. Go Mags\n3. B-Movie Blazers"
    },
    {
        id: nanoid(),
        title: "2024/25",
        podiumWinners: "1. Indy Halicopters\n 2. The Crashalot Bobcat\n3. Chicago's on Fire"
    }
]